import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { BasicFetch } from '../../../utils/BasicFetch.ts';
import { Badge, Button, FormControl, FormGroup, ListGroupItem } from 'react-bootstrap';
import { CollectionReptileLabel, CollectionReptile } from '../types/CollectionTypes.ts';
import { Typeahead } from 'react-bootstrap-typeahead';

export const CollectionReptileLabelModal = ({ show, collectionReptile, closePopup, setReptile }: {
  show: boolean
  collectionReptile: CollectionReptile,
  closePopup: () => void,
  setReptile: (reptile: CollectionReptile) => void
}) => {
  const [labelText, setLabelText] = useState('');
  const [allLabels, setAllLabels] = useState<CollectionReptileLabel[]>([]);
  const [creating, setCreating] = useState(false);
  const ref = useRef(null);

  const getLabels = () => {
    BasicFetch({
      url: `${(window as any).serverLocation}collection_reptile/get_labels`,
      method: 'GET',
      onSuccess: ({ labels }: { labels: CollectionReptileLabel[], }) => {
        setAllLabels(labels);
      },
    })
  }
  const createLabel = () => {
    setCreating(true);
    let creatingLabel = labelText;
    if (ref.current?.getInput().value) {
      creatingLabel = ref.current.getInput().value;
    }

    BasicFetch({
      url: `${(window as any).serverLocation}collection_reptile/${collectionReptile.id}/create/label`,
      method: 'POST',
      data: { label: creatingLabel },
      onSuccess: ({ labels }: { labels: CollectionReptileLabel[], }) => {
        setAllLabels(labels);
        setReptile({ ...collectionReptile, labels });
        setLabelText('')
        // reset the input
        if (ref.current) {
          (ref.current as any).clear();
        }

      }, onFinish: () => {
        setCreating(false);
      }
    })
  }
  const deleteLabel = (labelId: number) => {
    BasicFetch({
      url: `${(window as any).serverLocation}collection_reptile/${collectionReptile.id}/label/${labelId}/delete`,
      method: 'DELETE',
      onSuccess: ({ labels }: { labels: CollectionReptileLabel[], }) => {
        setAllLabels(labels);
        setReptile({ ...collectionReptile, labels });
      },
    })
  }

  useEffect(() => {
    getLabels();
  }, []);

  return (
    <>
      <div id='reptile-selector-shadow' style={{
        display: show ? 'block' : 'none',
      }} className='shadow fadeIn animated' onClick={(event) => {
        // if anything but the calendar is clicked, close the calendar
        if (event.target?.id === "reptile-selector-shadow") {
          closePopup();
        }
      }}>
        <div id="reptile-selector-popup" className='d-flex flex-column fadeIn animated rounded'>
          <div className='d-flex justify-content-center mb-3'>
            <h5 className='text-light'>Create Labels</h5>
            <FontAwesomeIcon icon={faTimes} size='xl' className='ml-auto' onClick={closePopup} style={{
              cursor: 'pointer',
            }} />
          </div>
          <FormGroup className='d-flex mb-3'>
            <Typeahead id='label-typeahead' ref={ref} allowNew options={allLabels.map(label => label.text)} renderInput={
              <FormControl className='h-100' placeholder='Search for a label or create one' />
            } placeholder='Search for a label or create one' className="bg-dark text-light w-100" onKeyDown={(e) => {
              if (e.code === "Enter") {
                createLabel()
              }
            }} onChange={(selected) => {
              if (selected.length > 0) {
                setLabelText(selected[0].label);
              }
            }
            } />
            <Button variant="outline-light" disabled={creating} onClick={createLabel}>
              {creating ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Add'}
            </Button>
          </FormGroup>

          {collectionReptile.labels.map(label => (
            <ListGroupItem key={label.id} className='d-flex justify-content-between bg-dark text-light'>
              {label.text}
              <Button variant="outline-danger" onClick={() => deleteLabel(label.id)}>
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </ListGroupItem>
          ))}
        </div>
      </div>
    </>
  )
};

